import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

type HomeIllustrationCardProps = {
  className?: string;
};

export const HomeIllustrationCard: FC<HomeIllustrationCardProps> = ({ className }) => {
  return <img src='/assets/image/home-campaign-bg.svg' alt='Create a campaign' className={twMerge('size-full object-contain', className)} />;
};
